import { Component, OnInit } from '@angular/core';
import { VerificationMarketerService } from '@api/verification-marketer.service';
import { MarketerService } from '@shared/services/marketer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import jalaliMoment = require('jalali-moment');


@Component({
  selector: 'app-verification-marketer',
  templateUrl: './verification-marketer.component.html',
  styleUrls: ['./verification-marketer.component.scss']
})
export class VerificationMarketerComponent implements OnInit {
  public destroy$ = new Subject<void>();
  marketerId;
  marketerPosition;
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  pageEvent: PageEvent;
  marketerList;
  constructor(
    private marketerService: MarketerService,
    private verificationMarketerService: VerificationMarketerService,
    private dialog: MatDialog
  ) { }
  ngOnInit() {
    this.setValueFieldMarketer();
    this.getValueUpdateList();
  }
  marketerStatusChange(id, inlineStatus) {
    this.verificationMarketerService.updateMarketer(id, { inline: inlineStatus }).subscribe((res) => console.log(res));
    this.setValueFieldMarketer();
  }
  setValueFieldMarketer() {
    this.verificationMarketerService.getMarketerList(this.startPage, this.pageSize).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.marketerService.sendMarketer(res);

      }
    )
  }
  getValueUpdateList() {
    this.marketerService.getMarketer().subscribe((res) => {
      this.marketerList = res;
      if(!(this.marketerList === null)){
        this.marketerList.forEach((element): any => {
          element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
        });
      }

    })
  }

  public getServerData(event?: PageEvent) {
    this.pageSize = event.pageSize;
    this.verificationMarketerService.getMarketerList((event.pageIndex) + 1, this.pageSize).pipe(takeUntil(this.destroy$)).subscribe(
      (res) => {
        this.marketerList = res;
        if(!(this.marketerList === null)){
          this.marketerList.forEach((element): any => {
            element.requestDate = jalaliMoment(element.requestDate).format('jYYYY/jMM/jDD hh:mm');
          });
        }
      }
    )
  }
}
